import { render, staticRenderFns } from "./historySendInformation.vue?vue&type=template&id=26a14cce&"
import script from "./historySendInformation.vue?vue&type=script&lang=js&"
export * from "./historySendInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports